import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(
  ({ spacing, radius, palette, breakpoints }: Theme) => ({
    wrapper: {
      textAlign: 'center',
      backgroundColor: palette.background.main,
      display: 'flex',
      justifyContent: 'center',
      padding: [150, 0],
    },

    messageWrapper: {
      minWidth: 550,
      margin: 0,
      position: 'unset',
    },

    messageContainer: {
      padding: spacing[6],
      backgroundColor: palette.background.light,
      border: [1, 'solid', palette.muted.main],
      borderRadius: radius.small,
      marginTop: spacing[4],
    },

    linksContainer: {
      position: 'relative',
      margin: spacing[4],
      overflow: 'hidden',
    },

    linksList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginLeft: -1,
      listStyleType: 'none',
    },

    linksListItem: {
      flexGrow: 1,
      flexBasis: 'auto',
      textAlign: 'center',
      borderRight: [1, 'solid', '#ccc'],
      backgroundColor: palette.background.light,

      '&:last-child': {
        borderRight: 'none',
      },
    },

    errorPage: {
      textAlign: 'center',
    },

    errorLogo: {
      position: 'fixed',
      top: spacing[5],
      left: spacing[5],
      margin: 0,
      width: 200,
      height: 30,

      [`@media (max-width: ${breakpoints.sm}px)`]: {
        position: 'relative',
        display: 'block',
        top: 0,
        left: 0,
        backgroundColor: palette.background.main,
      },
    },
  })
);

export default useStyles;
